/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2024 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: /src/mixins/currencyFormat.js                                         *
 * Project: frontend                                                           *
 * Created Date: Thursday, May 2nd 2024, 6:43:03 pm                            *
 * Author: Prudhvi Teja <prudhvi@codestax.ai>                                  *
 * -----                                                                       *
 * Last Modified: May 2nd 2024, 7:10:56 pm                                     *
 * Modified By: Prudhvi Teja                                                   *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

export const currencyFormat = {
    inheritAttrs: false,
    methods: {
        formatCurrencyValue(currencyCode,digitsAfterdecimalPoint,currencyAmount,system,currencydisplay){
            if(!currencyCode){
                currencyCode = "USD";
            }
            if(!digitsAfterdecimalPoint){
                digitsAfterdecimalPoint = 2;
            }
			const currencyFormatConfig = {
                style: "currency",
                currency: currencyCode,
                minimumFractionDigits: digitsAfterdecimalPoint,
                currencyDisplay: currencydisplay === "code" ? "code" : "narrowSymbol"
            }
            if(system === "English") {
                let englishNumberFormatter = new Intl.NumberFormat("en-GB", currencyFormatConfig);
                if(currencydisplay === 'symbolAndCode'){
                    return `${currencyCode} ${englishNumberFormatter.format(currencyAmount)}`
                }
                return englishNumberFormatter.format(currencyAmount)
            }
            else if(system === "Arabic") {
                let arabicNumberFormatter = new Intl.NumberFormat("en-IN", currencyFormatConfig);
                if(currencydisplay === 'symbolAndCode'){
                    return `${currencyCode} ${arabicNumberFormatter.format(currencyAmount)}`
                }
                return arabicNumberFormatter.format(currencyAmount)
            }
            else {
                let defaultNumberFormatter = new Intl.NumberFormat("en-GB", currencyFormatConfig);
                if(currencydisplay === 'symbolAndCode'){
                    return `${currencyCode} ${defaultNumberFormatter.format(currencyAmount)}`
                }
                return defaultNumberFormatter.format(currencyAmount)
            }
		},
    }
}